import Link from "next/link";

import { PropTypes } from "prop-types";

function Breadcrumbs({ breadcrumbs = [] }) {
  return (
    <div className={`text-[0.875rem] leading-[1.375rem]`}>
      <ul>
        {breadcrumbs.length > 1 && (
          <>
            {breadcrumbs
              ?.slice(0, breadcrumbs.length - 1)
              ?.map((breadcrumb) => (
                <li key={breadcrumb.value} className="inline text-tertiary-500">
                  <span className="underline-offset-[0.188rem] hover:underline">
                    <Link href={`/${breadcrumb.link}`}>{breadcrumb.value}</Link>
                  </span>
                  <span>{` / `}</span>
                </li>
              ))}
          </>
        )}
        <li className="inline text-grayDisplay-900">
          {breadcrumbs.length > 1 &&
          breadcrumbs[breadcrumbs.length - 1].value?.length > 20
            ? `${breadcrumbs[breadcrumbs.length - 1].value.slice(0, 20)}...`
            : breadcrumbs[breadcrumbs.length - 1]?.value}
        </li>
      </ul>
    </div>
  );
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.array,
};

export default Breadcrumbs;
